import { http } from './http';
import { baseURL, pushEndpoint } from './wpConfig';
import { UserCredentials } from './wpAuth';

export interface PushPublicKeyResponse {
    publicKey: string;
}

export interface PushSubscribeResponse {
    subscribed: boolean;
    id?: number;
}

export interface PushUnsubscribeResponse {
    unsubscribed?: boolean;
}

export interface PushTestPayload {
    title: string;
    body: string;
    url?: string;
}

/** VAPID public key for subscribe(); no auth. */
export const getPublicKey = (): Promise<PushPublicKeyResponse> => {
    const endPoint = baseURL + pushEndpoint + '/public-key';
    return http.get<PushPublicKeyResponse>(endPoint);
};

export const subscribePush = (
    userCredentials: UserCredentials,
    subscription: PushSubscriptionJSON
): Promise<PushSubscribeResponse> => {
    const endPoint = baseURL + pushEndpoint + '/subscribe';
    return http.post<PushSubscribeResponse>(endPoint, subscription, { auth: userCredentials });
};

export const unsubscribePush = (
    userCredentials: UserCredentials,
    subscription: PushSubscriptionJSON
): Promise<PushUnsubscribeResponse> => {
    const endPoint = baseURL + pushEndpoint + '/unsubscribe';
    return http.del<PushUnsubscribeResponse>(endPoint, {
        auth: userCredentials,
        body: subscription,
    });
};

/** For manual / scripted testing (curl); not wired in UI. */
export const sendTestNotification = (
    userCredentials: UserCredentials,
    payload: PushTestPayload
): Promise<unknown> => {
    const endPoint = baseURL + pushEndpoint + '/test';
    return http.post(endPoint, payload, { auth: userCredentials });
};
